// removed by extract-text-webpack-plugin
module.exports = {"container":"IndexPage__container__3kpp7","titleWrapper":"IndexPage__titleWrapper__24k0e","title":"IndexPage__title__rHyG7","left":"IndexPage__left__2PCQb","middle":"IndexPage__middle__2gLro","right":"IndexPage__right__zglBp","scroll":"IndexPage__scroll__1fMN-","line":"IndexPage__line__1BdyA","carousel":"IndexPage__carousel__2Z3mq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexPage/IndexPage.scss
// module id = 675
// module chunks = 0